<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        {{ selectedBuyNum !== undefined ? `ویرایش سفارش خرید ${selectedBuyNum}` : 'ثبت سفارش خرید' }}
        {{ selectedCustomer !== undefined ? selectedCustomer.Cs_Name : '' }}
        <q-btn icon="info" round flat name="info" size="md" v-if="selectedBuyNum!==undefined"
               @click="showCustomerInfo(selectedCustomer)"/>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding" v-if="selectedCustomer===undefined">
      <q-toggle v-model="immediatelySale" label="سفارش خرید جهت یک فروش فوری و یا فروش فروشگاهی است"/>
      <SelectCustomer :buy-list="true" :selected-customer="selectedCustomer" @customerSelected="customerSelected"/>
    </q-card-section>
    <q-card-section class="no-padding" v-if="immediatelySale">
      <SelectCustomer :buy-list="false" :selected-customer="immediatelySaleCustomer"
                      @customerSelected="immediatelyCustomerSelected"/>
    </q-card-section>
    <q-card-section v-if="selectedCustomer!==undefined" class="no-padding">
      <div :class="$q.screen.lt.md?'row full-width':'row full-width q-gutter-sm'">
        <div class="col col-xs-12 col-md-5">
          <q-card-section class="no-padding q-mb-xs" v-if="immediatelySale">
            <q-banner rounded class="bg-deep-orange-10 text-white" inline-actions dense>
              <span>فروش فوری</span>
              <template v-slot:action>
                <q-chip v-if="selectedCustomer" :label="selectedCustomer.Cs_Name" square/>
                <q-chip v-if="immediatelySaleCustomer" icon="arrow_back" square/>
                <q-chip v-if="immediatelySaleCustomer" :label="immediatelySaleCustomer.Cs_Name" square/>
              </template>
            </q-banner>
          </q-card-section>

          <q-expansion-item class="q-mb-xs text"
                            :class="$q.screen.lt.md?'shadow-1 overflow-hidden q-mt-sm':'shadow-1 overflow-hidden'"
                            style="border-radius: 10px"
                            v-if="selectedCustomer"
                            icon="shopping_cart"
                            label="پروفایل تامین کننده"
                            header-class="bg-indigo-10 text-white"
                            expand-icon-class="text-white">
            <div class="row full-width flex flex-center" v-if="!$q.screen.lt.md">
              <CustomerInfo :selected-customer="selectedCustomer" :dialog="false" :buy-list="true"/>
            </div>
            <CustomerInfo v-if="$q.screen.lt.md" :selected-customer="selectedCustomer" :dialog="false"
                          :buy-list="true"/>
          </q-expansion-item>
          <q-expansion-item class="q-mb-xs text"
                            :class="$q.screen.lt.md?'shadow-1 overflow-hidden q-mt-sm':'shadow-1 overflow-hidden'"
                            style="border-radius: 10px"
                            v-if="immediatelySaleCustomer"
                            icon="shopping_cart"
                            label="پروفایل مشتری"
                            header-class="bg-indigo-10 text-white"
                            expand-icon-class="text-white">
            <div class="row full-width flex flex-center">
              <CustomerInfo :selected-customer="immediatelySaleCustomer" :dialog="false" :buy-list="true"/>
            </div>
          </q-expansion-item>
          <q-expansion-item
              v-if="(!immediatelySale && selectedCustomer) || (immediatelySale && selectedCustomer && immediatelySaleCustomer)"
              :class="$q.screen.lt.md?'shadow-1 overflow-hidden q-mt-sm':'shadow-1 overflow-hidden'"
              style="border-radius: 10px"
              icon="shopping_cart"
              label="لیست کالاها"
              header-class="bg-indigo-10 text-white"
              expand-icon-class="text-white"
              default-opened>
            <ProductInfoSearchPanel @cancel-product-search="clearItems"/>
            <ProductInfoSearchResult :is-selection-form="true"
                                     :buy-list="true"
                                     :show-groups="true"
                                     :by-pass-insert-dialog="false"
                                     description-select-good-dialog="تعداد سفارش را وارد نمایید"
                                     title-select-good-dialog="تعداد سفارش"
                                     @select-goods="selectedGood"/>
          </q-expansion-item>
        </div>
        <div class="col-xs-12 col-md-6"
             v-if="(!immediatelySale && selectedCustomer) || (immediatelySale && selectedCustomer && immediatelySaleCustomer)">
          <q-expansion-item
              :class="$q.screen.lt.md?'shadow-1 overflow-hidden q-mt-sm':'shadow-1 overflow-hidden'"
              style="border-radius: 10px"
              icon="shopping_cart"
              label="اقلام سفارش"
              header-class="bg-indigo-10 text-white"
              expand-icon-class="text-white"
              default-opened>
            <BuyGoodsList :items="goodsItems"
                          :immediately-sale-customer="immediatelySaleCustomer"
                          :buy-num="parseInt(selectedBuyNum)"
                          @goods-deleted="goodsDeleted"
                          @clear-items="clearItems"
                          :buy-description="selectedBuyDesc"
                          :selected-customer="selectedCustomer"/>
          </q-expansion-item>

        </div>
      </div>
    </q-card-section>
    <q-dialog v-model="customerInfoDialog" :maximized="$q.screen.lt.md">
      <CustomerInfo :selected-customer="selectedCustomer" :dialog=" true" :buy-list="true"/>
    </q-dialog>
  </q-card>
</template>

<script>
import SelectCustomer from "@/components/customers/SelectCustomer";
import ProductInfoSearchPanel from "@/components/productInfo/ProductInfoSearchPanel";
import ProductInfoSearchResult from "@/components/productInfo/ProductInfoSearchResult";
import BuyGoodsList from "@/components/Buys/‌BuyGoodsList";
import EventBus from "@/event-bus";
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";

export default {
  name: "BuyOrder",
  components: {CustomerInfo, BuyGoodsList, ProductInfoSearchResult, ProductInfoSearchPanel, SelectCustomer},
  data() {
    return {
      customerInfoDialog: false,
      selectedCustomer: undefined,
      selectedSaleCustomer: undefined,
      immediatelySale: false,
      immediatelySaleCustomer: undefined,
      immediatelySaleCustomerName: undefined,
      selectedCustomerName: undefined,
      selectedBuyNum: undefined,
      goodsItems: [],
      selectedBuyDesc: undefined
    }
  },
  methods: {
    ...mapActions({
      getProductListBuGroupID: 'Products/getByGroupID',
      getCustomerInfo: 'Customers/get_customer_info',
      getOrderDetails: 'Buys/getOrderDetails',
      getOrder: 'Buys/getOrder'
    }),
    showCustomerInfo() {
      this.customerInfoDialog = true
    },
    goodsDeleted(args) {
      const founded = this.goodsItems.findIndex(item => item.Goods_ID === args.Goods_ID)
      this.$delete(this.goodsItems, founded)
    },
    customerSelected(args) {
      this.selectedCustomer = args
    },
    immediatelyCustomerSelected(args) {
      this.immediatelySaleCustomer = args
    },
    clearItems() {
      this.goodsItems = []
      this.selectedCustomer = undefined
      this.immediatelySaleCustomer = undefined
      this.immediatelySale = false
    },
    selectedGood(args) {
      const cloneGoods = Object.assign({}, args)
      cloneGoods.BuyLast_Price = cloneGoods.BuyLast_Price ? cloneGoods.BuyLast_Price : cloneGoods.BuyDay_Price
      const founded = this.goodsItems.find(item => item.Goods_ID === cloneGoods.Goods_ID)
      if (founded === undefined) {
        this.goodsItems.push(cloneGoods)
      } else {
        this.$q.notify({
          message: 'کالا تکراری است',
          type: 'negative',
          position: 'top',
          color: 'negative'
        })
      }
    },
    groupSelected(args) {
      EventBus.$emit('invoke-group-selected-event', args);
      this.getProductListBuGroupID(args.Group_ID).then((res) => {
        this.productList = res
        EventBus.$emit('invoke-productinfo-search-result-event', this.productList);
      })

    }
  },
  created() {
    if (this.$route.params.id) {
      this.getOrder(
          {
            buyNum: this.$route.params.id,
            buyKind: 1
          }
      ).then((res) => {
        this.selectedBuyDesc = res[0].Buy_Desc
      })
      this.getOrderDetails({
        buyNum: this.$route.params.id,
        buyKind: 1
      }).then((res) => {
        this.selectedBuyNum = this.$route.params.id
        this.goodsItems = res
      })
    }
    if (this.$route.params.customerId) {
      this.getCustomerInfo(this.$route.params.customerId).then((res) => {
        this.selectedCustomer = res.data[0]
      })
    }
  }
}
</script>

<style scoped>

</style>